module.exports = __webpack_public_path__ + "img/info-icon.9a4cf62c.svg";